import { combineReducers } from "redux";

import { mealsDetails } from "./reducer.meals"
const mealsReducers = combineReducers({
    mealsDetails
})
export default mealsReducers;
